function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";

import { NotificationIcon, WarningIcon, CheckCircleIcon, CancelIcon } from '@cxagroup/casper-icons';

var NotificationLevel = {
  notification: "notification",
  warning: "warning",
  success: "success",
  error: "error"
};

var LevelIcon = {
  notification: NotificationIcon,
  warning: WarningIcon,
  success: CheckCircleIcon,
  error: CancelIcon
};

var getLevelIcon = function getLevelIcon(level) {
  return level && LevelIcon[level];
};

var Notification = function (_Component) {
  _inherits(Notification, _Component);

  function Notification() {
    _classCallCheck(this, Notification);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Notification.prototype.render = function render() {
    var _props = this.props,
        message = _props.message,
        level = _props.level,
        children = _props.children;


    if (message) {
      console.warn("`message` is deprecated");
    }

    var Icon = getLevelIcon(level);

    return React.createElement(
      "div",
      { className: "csp-notification csp-notification--" + level },
      React.createElement(Icon, { className: "icon icon--" + level }),
      children ? children : message
    );
  };

  return Notification;
}(Component);

Notification.propTypes = process.env.NODE_ENV !== "production" ? {
  level: PropTypes.string.isRequired,
  message: PropTypes.string
} : {};

Notification.level = NotificationLevel;

export default Notification;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/notification/Notification.js
// module id = null
// module chunks = 